import { vocabularyConstants } from '../../constants';

const initialVocabularyState = {
  vocabularyList: [] as any[],
  stats: {
    total: 0,
    ielts_count: 0,
    toeic_count: 0,
    levels: []
  },
  pagination: {
    page: 1,
    limit: 20,
    total: 0,
    totalPages: 0,
  },
  loading: false,
  error: null,
};

export function vocabulary(state = initialVocabularyState, action: any) {
  switch (action.type) {
    case vocabularyConstants.GETALL_REQUEST:
      // Chỉ set loading = true nếu chưa có data (lần đầu load)
      return { ...state, loading: state.vocabularyList.length === 0 };
    case vocabularyConstants.GETALL_SUCCESS:
      return {
        ...state,
        vocabularyList: action.payload.data || [],
        pagination: action.payload.pagination || state.pagination,
        loading: false,
        error: null,
      };
    case vocabularyConstants.GETALL_FAILURE:
      return { ...state, error: action.payload, loading: false };

    case vocabularyConstants.GET_STATS_REQUEST:
      return { ...state, loading: true };
    case vocabularyConstants.GET_STATS_SUCCESS:
      return {
        ...state,
        stats: action.payload.data,
        loading: false,
        error: null,
      };
    case vocabularyConstants.GET_STATS_FAILURE:
      return { ...state, error: action.payload, loading: false };

    case vocabularyConstants.CREATE_REQUEST:
      return { ...state, loading: true };
    case vocabularyConstants.CREATE_SUCCESS:
      return {
        ...state,
        vocabularyList: [action.payload.data, ...state.vocabularyList],
        loading: false,
        error: null,
      };
    case vocabularyConstants.CREATE_FAILURE:
      return { ...state, error: action.payload, loading: false };

    case vocabularyConstants.UPDATE_REQUEST:
      return { ...state, loading: true };
    case vocabularyConstants.UPDATE_SUCCESS:
      return {
        ...state,
        vocabularyList: state.vocabularyList.map((vocab) =>
          vocab.id === action.payload.data.id ? action.payload.data : vocab
        ),
        loading: false,
        error: null,
      };
    case vocabularyConstants.UPDATE_FAILURE:
      return { ...state, error: action.payload, loading: false };

    case vocabularyConstants.DELETE_REQUEST:
      return { ...state, loading: true };
    case vocabularyConstants.DELETE_SUCCESS:
      return {
        ...state,
        vocabularyList: state.vocabularyList.filter((vocab) => vocab.id !== action.payload),
        loading: false,
        error: null,
      };
    case vocabularyConstants.DELETE_FAILURE:
      return { ...state, error: action.payload, loading: false };

    case vocabularyConstants.SEARCH_REQUEST:
      return { ...state, loading: true };
    case vocabularyConstants.SEARCH_SUCCESS:
      return {
        ...state,
        vocabularyList: action.payload.data || [],
        loading: false,
        error: null,
      };
    case vocabularyConstants.SEARCH_FAILURE:
      return { ...state, error: action.payload, loading: false };

    default:
      return state;
  }
}
